import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";

function Contacto() {
  return (
    <Container className="py-5">
      <Row className="align-items-center g-5">
        {/* Columna izquierda: Información de contacto */}
        <Col md={6}>
          <div className="bg-dark text-white p-4 rounded-4 shadow">
            <h2 className="mb-4">¿Cómo querés comunicarte con nosotros?</h2>
            <p className="fs-5 mb-3">
              📧 Email:{" "}
              <span className="text-warning fw-semibold">
                colegiosantotomasageneral@gmail.com
              </span>
            </p>
            <p className="fs-5 mb-3">
              📸 Instagram:{" "}
              <span className="text-warning fw-semibold">
                @santotomasisinstitucional
              </span>
            </p>
            <p className="fs-5 mb-0">
              📞 Teléfono:{" "}
              <span className="text-warning fw-semibold">2654-313911</span>
            </p>
          </div>
        </Col>

        {/* Columna derecha: Formulario */}
        <Col md={6}>
          <Form className="bg-white p-5 rounded-4 shadow-lg">
            <h3 className="text-center mb-4 text-dark fw-bold">Contacto</h3>

            <Form.Group className="mb-3">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                placeholder="Escribe tu nombre"
                className="rounded-pill p-3"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Escribe tu e-mail"
                className="rounded-pill p-3"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Escribe tu teléfono"
                className="rounded-pill p-3"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Mensaje</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Escribe tu mensaje"
                className="rounded-4 p-3"
              />
            </Form.Group>

            <div className="text-end">
              <Button
                type="submit"
                variant="warning"
                className="fw-bold px-4 py-2 rounded-pill text-dark"
                style={{ transition: "all 0.3s ease" }}
                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
              >
                Enviar mensaje
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default Contacto;
